<div class="tooltip" *ngIf="isUnconfirmedInBackCount$ | async">
    <img class="ml-1"
    [src]="'assets/icons/icon-warning-red.svg'"
    [ngClass]="imgClass"/>
    <span class="tooltiptext">Unresolved back-count discrepancy</span>
  </div>